<script lang="ts">
	import type AuthProvider from '$lib/components/auth/store.svelte';

	import { browser } from '$app/environment';
	import { getContext, onMount } from 'svelte';

	const authProvider = getContext<AuthProvider>('auth');

	const { tagId }: { tagId?: string } = $props();

	onMount(() => {
		if (!browser || !tagId || typeof pintrk === 'undefined') return;

		const hashedEmail = authProvider?.userData?.hashedEmail;
		const loadOptions = hashedEmail ? { em: hashedEmail } : undefined;
		pintrk('load', tagId, loadOptions);
		pintrk('page');
	});
</script>

{/* eslint-disable @typescript-eslint/no-unused-expressions */ null}
<svelte:head>
	{#if tagId}
		{@html `
    <!-- Pinterest Pixel Code -->
		<script>
			!function(e){if(!window.pintrk){window.pintrk = function () {
				window.pintrk.queue.push(Array.prototype.slice.call(arguments))};var n=window.pintrk;n.queue=[],n.version="3.0";var t=document.createElement("script");t.async=!0,t.src=e;var r=document.getElementsByTagName("script")[0]; r.parentNode.insertBefore(t,r)}}("https://s.pinimg.com/ct/core.js");
		</script>
		<!-- End Pinterest Pixel Code -->
		`}
	{/if}
</svelte:head>
{/* eslint-enable @typescript-eslint/no-unused-expressions */ null}
